import { EVENT_TYPE, STRING } from 'resources'
import { intercomBubble } from 'resources/images'
import { sendAnalyticsEvent } from 'services/analytics'

import { intercomShowMessenger } from 'services/Intercom'

import { IntercomButton, IntercomIcon } from './styles'

const IntercomBubble = () => {
  const intercomBubbleClick = () => {
    sendAnalyticsEvent(EVENT_TYPE.reklaimScreenIntercomClick)
    intercomShowMessenger()
  }

  return (
    <IntercomButton onClick={intercomBubbleClick}>
      <IntercomIcon src={intercomBubble} alt={STRING.intercom.messengerButtonAlt} />
    </IntercomButton>
  )
}

export default IntercomBubble
